import React from "react";

/**
 * Reusable Decorative Grid Lines Component - Variant 3 (Intro Screen)
 *
 * Design Spec:
 * - Positioned on the right side of screen (6 cols x 5 rows)
 * - Rows 3 & 4, Columns 1 & 2 contain a 3x3 mini grid of smaller boxes
 *
 * @param {string} variant - Optional layout variant name
 * @param {string} label - Optional target node label
 */
const DecorativeLines3 = ({ variant = "default", label = "" }) => {
    const rows = [1, 2, 3, 4, 5];
    const cols = [1, 2, 3, 4, 5, 6];
    const miniSubgridCols = [1, 2, 3, 4, 5, 6, 7, 8, 9];

    return (
        <div className={`DecorativeLines3 DecorativeLines3--${variant}`}>
            <div className="DecorativeLines3__grid">
                {rows.map((rowIndex) => (
                    <div
                        key={`row-${rowIndex}`}
                        className={`DecorativeLines3__row DecorativeLines3__row--${rowIndex}`}
                    >
                        {cols.map((colIndex) => {
                            const isSubgridCell =
                                (rowIndex === 3 || rowIndex === 4) &&
                                (colIndex === 1 || colIndex === 2);

                            return (
                                <div
                                    key={`cell-${rowIndex}-${colIndex}`}
                                    className={`DecorativeLines3__cell ${
                                        isSubgridCell
                                            ? "DecorativeLines3__cell--subgrid"
                                            : ""
                                    }`}
                                >
                                    {isSubgridCell && (
                                        <div className="DecorativeLines3__mini-grid">
                                            {miniSubgridCols.map((subIndex) => (
                                                <div
                                                    key={`sub-${subIndex}`}
                                                    className="DecorativeLines3__mini-cell"
                                                />
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DecorativeLines3;
